import React, { Fragment, useState, useEffect } from "react";
import "./styles.css";

import { ReactComponent as TickIcon } from "common/assets/svg/tickIconOffer.svg";
import { ReactComponent as Cancel } from "common/assets/svg/cancel.svg";

import { useSpring, useTransition, animated } from "react-spring";
import { useHistory, useParams, useLocation } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "common/rootReducer";
import { setCartAuthPending } from "common/features/cart/cartActions";
import LoginPromt from "components/prompts/loginPromt";
import SignupPopup from "../signupPopup";

function LoginRequest(props: any) {
  const dispatch = useDispatch();
  const location = useLocation<any>();
  const isMobile = window.innerWidth <= 500;

  const {
    isOpen,
    visible,
    title,
    subtext,
    cartUrl,
    // setIsOpen,
  } = props;
  const history = useHistory();

  const opacityProps = useSpring({
    from: { opacity: 0 },
    to: { opacity: isOpen ? 1 : 0 },
  });

  const [loginPopup, setLoginPopup] = useState(false);
  const [signupPopup, setSignupPopup] = useState(false);


  const setLoginOpen = (set: boolean) => {    
    if (set) {
      setLoginPopup(false);
    }else{
      setLoginPopup(true);
    }
  };

  const setIsOpen = (set: boolean) => {
    if (set) {
      setSignupPopup(false);
    }else{
      setSignupPopup(true);
    }
  };

  const transitions = useTransition(isOpen, null, {
    from: { transform: "translate3d(0,-15px,0)" },
    enter: { transform: "translate3d(0,0px,0)" },
    leave: { transform: "translate3d(0,-15px,0)" },
    unique: true,
  });

  return (
    <Fragment>
      {isOpen ? (
        <Fragment>
          <div id="modal-background" style={{ zIndex: '20' }}></div>
          <animated.div className="CPWrapper" style={opacityProps}>
            {transitions.map(({ item, key, props }) =>
              item ? (
                <animated.div className="CPContainer" key={key} style={props}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span className="login-title-text">{title}</span>
                    <Cancel onClick={() => visible(true)} />
                  </div>
                  <div className="subtext-container">
                    <span>{subtext}</span>
                  </div>
                  <div className="login-button-container">
                    <div
                      className="bottom-login-button"
                      onClick={() => {
                        if (isMobile) {
                          dispatch(
                            setCartAuthPending(
                              true,
                              cartUrl ? cartUrl : location.pathname
                            )
                          );

                          history.push("/SignIn");
                        } else {
                          setLoginPopup(true);
                          visible(true);
                        }
                      }}
                    >
                      Login
                    </div>
                  </div>
                </animated.div>
              ) : null
            )}
          </animated.div>
        </Fragment>
      ) : null}
      {
        !isMobile && <LoginPromt
        isOpen={loginPopup}
        visible={setLoginOpen}
        openSignUpPopoup={()=>{setIsOpen(false);setLoginOpen(true)}}
      />}
      {!isMobile &&    <SignupPopup
      isOpen={signupPopup}
      visible={setIsOpen}
      title={" Login to avail offer"}
      subtext={" You need to login to apply this promocode."}
      cartUrl={cartUrl}
      //setGuestPopup={setloginGuestPopup}
      //setloginRequestPopup={setloginRequestPopup}
    />
      }
    </Fragment>
  );
}

export default LoginRequest;
